<template>
  <div>
    <p >{{ title }}</p>
    <p>{{ color }}</p>
  </div>
</template>
<script>
export default {
  name: "test_props",
  props:['title','color'],
  data: function () {
    return {
    };
  },
};
</script>